import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/lathe.jpg'


const _hoisted_1 = { style: {"margin-top":"5em"} }
const _hoisted_2 = { class: "container text-center mb-5 w-75" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "text-muted text-center pb-4" }, "custom instruments", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("img", {
        src: _imports_0,
        style: {"width":"50%"},
        class: "pb-5"
      }, null, -1)),
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode(" Every instrument I make can be built to your specifications — whether it's an ", -1)),
        _cache[1] || (_cache[1] = _createElementVNode("b", null, "Irish flute", -1)),
        _cache[2] || (_cache[2] = _createTextVNode(", a ", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("b", null, "headjoint", -1)),
        _cache[4] || (_cache[4] = _createTextVNode(" for your Boehm flute, or a ", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("b", null, "whistle", -1)),
        _cache[6] || (_cache[6] = _createTextVNode(". ", -1)),
        _createVNode(_component_LinkComponent, {
          href: "/#contact",
          "link-text": "Contact me"
        }),
        _cache[7] || (_cache[7] = _createTextVNode(" to talk it through. ", -1))
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("p", null, " Available materials range from different hardwoods to aluminium and brass. There are technical restrictions regarding bore, wall thickness, the combination of materials and so on — I'm happy to consult with you to arrive at something that plays and works well. ", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("p", null, " Tell me what you have in mind: the sound you're after, your budget, and any preferences on material, tuning or keys. ", -1))
    ])
  ]))
}